<template lang="pug">
#league-modal
  leagueBar(v-model="leagueSearch" @save="saveLeague")
  template(v-for="(sItem, sKey, sIndex) in sports")
    template(v-if="getFilterLeagueList(sKey).length > 0")
      .select-league
        .single-league
          label.remember.d-flex
            .check-wrap
              input(type="checkbox" v-model="leagueAllSelected" @click="rowSelect('all')")
              span.checkmark
            .blue.flex-grow-1 {{ $t("ui.check_all") }}
        template(v-for="(lItem, lKey, lIndex) in getFilterLeagueList(sKey)")
          .single-league
            label.remember.d-flex
              .check-wrap
                input(type="checkbox" :checked="checkLeague(lItem)" @click="rowSelect(lItem)")
                span.checkmark
              .blue.flex-grow-1 {{ lItem[4] }}
              //- .badge-league 5
</template>

<script>
import leagueBar from "@/components/mobile/leagueBar";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    leagueBar
  },
  data() {
    return {
      lastInitialized: 0,
      leagueSearch: "",
      leagueIdSelected: [],
      leagueAllSelected: true
    };
  },
  computed: {
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  destroyed() {
    EventBus.$off("LEAGUE_MODAL_SHOW", this.busModal);
  },
  mounted() {
    $("#cancel-league").click(function() {
      $("#league-modal").fadeOut();
    });

    EventBus.$on("LEAGUE_MODAL_SHOW", this.busModal);
  },
  methods: {
    busModal(epoch) {
      if (epoch != this.lastInitialized) {
        this.initial();
        this.lastInitialized = epoch;
      }
    },
    initial() {
      this.leagueIdSelected = [];
      if (this.$store.getters.selectLeague != null) {
        if (this.$store.getters.selectLeague.length > 0) {
          this.leagueIdSelected = this.$store.getters.selectLeague.slice();
          this.leagueAllSelected = this.$store.getters.selectLeague.length == Object.values(this.$store.state.layout.league).length ? true : false;
        } else {
          var tempList = Object.values(this.$store.state.layout.league);
          for (var i = 0; i < tempList.length; i++) {
            this.leagueIdSelected.push(tempList[i][0]);
          }
          this.leagueAllSelected = true;
        }
      }
    },
    leaguesList() {
      if (this.$store.state.layout.league != null) {
        var tempList = Object.values(this.$store.state.layout.league);
        return tempList.filter(item => {
          return item[4].toLowerCase().indexOf(this.leagueSearch.toLowerCase()) > -1;
        });
      } else {
        return null;
      }
    },
    getFilterLeagueList(sportId) {
      let llnn = this.leaguesList();

      if (llnn) {
        return this.leaguesList().filter(item => {
          return item[1] == sportId;
        });
      } else {
        return [];
      }
    },
    rowSelect: function(info) {
      if (info != "all") {
        var index = this.leagueIdSelected.indexOf(info[0]);
        if (index == -1) {
          this.leagueIdSelected.push(info[0]);
          this.leagueAllSelected = this.leagueIdSelected.length == Object.values(this.$store.state.layout.league).length ? true : false;
        } else {
          this.leagueIdSelected.splice(index, 1);
          this.leagueAllSelected = false;
        }
      } else {
        if (this.$store.state.layout.league != null) {
          var tempList = Object.values(this.$store.state.layout.league);

          setTimeout(() => {
            if (this.leagueAllSelected) {
              for (var i = 0; i < tempList.length; i++) {
                var index = this.leagueIdSelected.indexOf(tempList[i][0]);
                if (index == -1) this.leagueIdSelected.push(tempList[i][0]);
              }
            } else {
              this.leagueIdSelected = [];
            }
          }, 10);
        }
      }
    },
    checkLeague(league) {
      return this.leagueIdSelected.indexOf(league[0]) >= 0;
    },
    saveLeague() {
      this.$store.dispatch("layout/setSelectLeague", this.leagueIdSelected);
    }
  }
};
</script>
